import { useFieldArray, useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import InputComponent from './component';

const Input = ({
  name,
  required = false,
  defaultValue = [],
  formatterMap,
  nameMap,
  readOnly,
  value,
  isLoading,
  ...restProps
}) => {
  const {
    control,
    setValue,
  } = useFormContext() || {};

  const {
    append, remove, fields, update,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name, // unique name for your Field Array,
    shouldUnregister: true,
  });
  const alreadyExistingField = fields.find((field) => typeof field.value === 'string' && nameMap?.[field.value]);

  useEffect(() => {
    if(alreadyExistingField) {
      const fixedValue = nameMap?.[alreadyExistingField.value];
      const fixedValueIndex = fields.findIndex((i) => i.id === alreadyExistingField.id);

      if(fields.find((field) => field.value === fixedValue)) {
        remove(fixedValueIndex);
      } else {
        update(fixedValueIndex, { value: fixedValue });
      }
    }
  }, [alreadyExistingField]);

  return (
    <InputComponent
      {...restProps}
      formatterMap={formatterMap}
      nameMap={nameMap}
      append={(tag) => {
        setValue(name, [...fields, tag], {
          shouldValidate: true,
          shouldTouch: true,
          shouldDirty: true,
        });
      }}
      remove={(index) => {
        setValue(name, fields.reduce((result, item, i) => {
          if(i !== index) {
            return [...result, item];
          }

          return result;
        }, []), {
          shouldValidate: true,
          shouldTouch: true,
          shouldDirty: true,
        });
      }}
      required={required}
      name={name}
      fields={fields}
      readOnly={readOnly}
    />
  );
};

export default Input;
